import React from "react";
import WorkloadDataForm from "./workload-data-form";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import WorkloadDataTables from "./workload-data-tables";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const WorkloadData = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_WORKLOAD_DATA",
      "AUDITOR_WORKLOAD_DATA"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("WORKLOAD_DATA")}
        subTitle={i18n.get("WORKLOAD_DATA_BETWEEN_TWO_DATES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <WorkloadDataForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <WorkloadDataTables />
    </ET3PageDiv>
  );
});
export default WorkloadData;
